

export function Loading(){
    return (
        <>
        <h2>Loading</h2>
        <p>Requestin the data, wait little bit</p>
        </>
    )
}